<template>
  <div>
    <div v-if="isReconnect" class="reconnect-feedback"> Reconectando... </div>
    <section>
      <div id="spearhead">
        <div v-if="protocol || clientInfo.name || clientInfo.phone || queue" class="d-flex">
          <div class="spearhead-element" v-if="protocol">
            <span><i class="fas fa-clipboard"></i><b>Protocolo</b></span>
            <p v-if="protocol">{{ protocol }}</p>
          </div>
          <div class="spearhead-element">
            <span><i class="fas fa-user"></i><b>Cliente</b></span>
            <p v-if="clientInfo.name">{{ clientInfo.name }}</p>
            <p v-else>----------</p>
          </div>
          <div class="spearhead-element">
            <span><i class="fas fa-phone"></i><b>Telefone</b></span>
            <p v-if="clientInfo.phone">{{ formatPhone(clientInfo.phone) }}</p>
            <p v-else>----------</p>
          </div>
          <div class="spearhead-element">
            <span><i class="fas fa-headset"></i><b>Fila de Atendimento</b></span>
            <p v-if="queue">{{ queueAlias }}</p>
            <p v-else>----------</p>
          </div>
          <div class="spearhead-element">
            <span><i class="fas fa-address-card"></i><b>Operador</b></span>
            <p v-if="clientInfo.operator">{{ clientInfo.operator }}</p>
            <p v-else>----------</p>
          </div>
          <div class="spearhead-element">
            <span><i class="fas fa-lock"></i><b>Código do Operador</b></span>
            <p v-if="clientInfo.codigo">{{ clientInfo.codigo }}</p>
            <p v-else>----------</p>
          </div>
          <div class="spearhead-element" v-if="clientInfo.cpf">
            <span><i class="fas fa-key"></i><b>CPF/CNPJ</b></span>
            <p v-if="clientInfo.cpf">{{ clientInfo.cpf }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      interval: "",
      time: "",
      timeFormat: "",
      protocol: "",
      clientInfo: {
        name: "",
        phone: "",
        cpf: "",
        operator: "",
        codigo: "",
        nameSearchConsultor: "",
      },
      queue: "",
      queueList: []
    };
  },
  computed: {
    ...mapGetters(["isReconnect", "getSpearheadData", "getStoreQueues"]),
    queueAlias() {
      const queue = this.queue ? this.queue : '---'
      if (this.queueList.length) {
        const find = this.queueList.find(el => el.name === this.queue)
        if (find?.alias) return find.alias;
      }
      return queue
    }
  },
  methods: {
    async setClientData(client) {
      if (client.type === 'phone') {
        if (client.protocol) this.protocol = client.protocol;

        this.clientInfo.phone = client.phone;
        this.queue = client.queue;

        if (client.cpf) this.clientInfo.cpf = client.cpf;

        if (client.callType !== 'ramalIncoming') {
          try {
            const response = await axios(`/share-client-cnpj?share=${client.phone}`);
            const data = response.data;

            if (data.length > 0) {
              this.clientInfo.cpf = client.cpf ? client.cpf : data[0]?.unique_key;

              if (data[0].operator_phone) {
                try {
                  const consultorResponse = await axios(`searchConsultorCode?share=${data[0].operator_phone}`);

                  if (consultorResponse.data && consultorResponse.data.length > 0) {
                    this.clientInfo.codigo = consultorResponse.data[0]?.code || null;
                    this.clientInfo.nameSearchConsultor = consultorResponse.data[0]?.name || null;
                  }
                } catch (error) {
                  console.error('Erro ao buscar consultor:', error);
                }
              }

              const operatorValue = data[0].operator;
              const hasValidOperator = operatorValue && operatorValue.trim() !== "";

              this.clientInfo.operator = hasValidOperator
                ? operatorValue
                : (this.clientInfo.nameSearchConsultor || "----------");

              this.clientInfo.name = data[0].name || "----------";

            } else {
              this.clientInfo.name = "----------";
              this.clientInfo.operator = "----------";
            }
          } catch (error) {
            console.error('Erro na requisição share-client-cnpj:', error);
            this.clientInfo.name = "----------";
            this.clientInfo.operator = "----------";
          }
        }
      }
    },
    formatPhone(tel) {
      if (tel.substr(0, 2) != '55') {
        return tel;
      }
      if ((tel.length == 10) || (tel.length == 11)) {
        const v1 = tel.replace(/\D/g, "");
        const v2 = v1.replace(/^(\d{2})(\d)/g, "($1) $2");
        const v3 = v2.replace(/(\d)(\d{4})$/, "$1-$2");
        return v3;
      }
      tel = tel.replace(/\D/g, "")
      tel = tel.replace(/^(\d)/, "+$1")
      tel = tel.replace(/(.{3})(\d)/, "$1($2")
      tel = tel.replace(/(.{6})(\d)/, "$1)$2")
      if (tel.length == 12) {
        tel = tel.replace(/(.{1})$/, "-$1")
      }
      else if (tel.length == 13) {
        tel = tel.replace(/(.{2})$/, "-$1")
      }
      else if (tel.length == 14) {
        tel = tel.replace(/(.{3})$/, "-$1")
      }
      else if (tel.length == 15) {
        tel = tel.replace(/(.{4})$/, "-$1")
      }
      else if (tel.length > 15) {
        tel = tel.replace(/(.{4})$/, "-$1")
      }
      tel = tel.replace("(", " (");
      tel = tel.replace(")", ") ");

      return tel;
    },
  },
  watch: {
    getSpearheadData(val) {
      console.log('val', val)
      this.setClientData(val);
      localStorage.setItem("clienteAtual", JSON.stringify(val));
      this.hasData = !!Object.keys(val).length;

      if (Object.keys(val).length === 0) {
        this.clientInfo = {
          name: "",
          phone: "",
          operator: "",
          codigo: "",
        };
        this.protocol = "";
        this.queue = "";
      }
    },
    getStoreQueues(val) {
      this.queueList = val
    }
  },
  mounted() {
    if (!localStorage.getItem("clienteAtual")) {
      this.hasData = false;
      return;
    }

    const clienteAtual = JSON.parse(localStorage.getItem("clienteAtual"));
    if (Object.keys(clienteAtual).length) {
      this.hasData = true;
      this.setClientData(clienteAtual);
    }
  },
};
</script>

<style scoped>
#spearhead {
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  border-radius: 0px 0px 14px 14px;
  font-size: 11px;
  background-color: white;
  margin: 2px;
  box-shadow: -1px 5px 7px 0px #9f9999;
  transition: 0.7s;
  transition-timing-function: ease;
  height: max-content;
}

.spearhead-element {
  display: flex;
  flex-direction: column;
  text-align: center;
  border-right: 1px solid lightgray;
  border-left: 1px solid lightgray;
  padding: 0px 10px;
}

.spearhead-element span {
  font-size: 12px;
  text-align: center;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reconnect-feedback {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: gray;
  color: white;
}

.parte-cima {
  box-shadow: 5px 3px 6px -6px black;
  padding: 1px 5px 2px 20px;
  background-color: #ecf0f1;
  max-height: 10em;
  overflow-x: auto;
}

.row {
  margin-right: 0 !important;
}

::-webkit-scrollbar {
  width: 0.18rem;
}

::-webkit-scrollbar-track {
  background: #f38630;
}

::-webkit-scrollbar-thumb {
  background: #1c869a;
}

.espaco-lado-lado {
  max-width: 270px;
  width: 100%;
  margin: 0.1em 0 0.1em 0;
}

.img {
  height: 1.7em;
}

b {
  font-size: 1.1em;
  margin-left: 0.5em;
}

p {
  margin: 0 5px;
}

span {
  font-size: 20px;
}
</style>
